module.exports = __webpack_public_path__ + "images/category_lp/camera/new/store_images/4_5b028617a96bc5f3873bcbdd7de6940d.png";